import { getCoverImage } from 'utils/utils'
export const posts = [
    {
        id: 'post001',
        pretitle: null,
        title: 'Inicio',
        subtitle: null,
        type: '',
        category: '',
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'inicio',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
        data: { pages: [], articles: [], sites: [] },
    },
    {
        id: 'post002',
        pretitle: null,
        title: 'Sobre el programa',
        subtitle: null,
        summary:
            'Nuestro programa de apoyo integral al paciente tiene como objetivo principal ayudarle a mejorar su adherencia al tratamiento, brindándole herramientas y beneficios que impacten su calidad de vida.',
        description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'sobre-el-programa',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/hero-sobre-el-programa.jpg',
            },
            thumbImage: {
                aspectRatio: '1/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-el-programa-thumb.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            featuredPages: [
                'datos-de-contacto',
                'que-ofrece-el-programa',
                'articulos-y-materiales',
            ],
        },
    },
    {
        id: 'post003',
        pretitle: null,
        title: 'Sobre mi enfermedad',
        subtitle: null,
        summary:
            '¿Tiene dudas? Consulte a su médico tratante, quién podrá resolver todas las dudas que le surjan acerca de su diagnóstico.',
        description: null,
        url: 'sobre-mi-enfermedad',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-mi-enfermedad-alta-definici%C3%B3n-opt.jpg',
            },
            thumbImage: {
                aspectRatio: '1/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-mi-enfermedad-alta-definici%C3%B3n-opt.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            posts: [
                'articulos-y-folletos-publicacion-1',
                'articulos-y-folletos-publicacion-2',
                'articulos-y-folletos-publicacion-3',
                'articulos-y-folletos-publicacion-4',
                'articulos-y-folletos-publicacion-5',
                'articulos-y-folletos-publicacion-6',
                'articulos-y-folletos-publicacion-7',
                'articulos-y-folletos-publicacion-8',
                'videos-publicacion-1',
                'videos-publicacion-2',
                'videos-publicacion-3',
                'videos-publicacion-4',
                'videos-publicacion-5',
                'videos-publicacion-6',
                'videos-publicacion-7',
                'videos-publicacion-8',
                'videos-publicacion-9',
            ],
        },
    },
    {
        id: 'post003',
        pretitle: null,
        title: 'Sobre mi tratamiento',
        subtitle: null,
        summary:
            'En esta sección encontrarás información para favorecer la adherencia y el correcto traslado y conservación de la medicación.',
        description: null,
        url: 'sobre-mi-tratamiento',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-mi-enfermedad-alta-definici%C3%B3n-opt.jpg',
            },
            thumbImage: {
                aspectRatio: '1/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-mi-enfermedad-alta-definici%C3%B3n-opt.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            featuredPages: [],
            posts: [
                'articulos-y-folletos-publicacion-1',
                'articulos-y-folletos-publicacion-2',
                'articulos-y-folletos-publicacion-3',
                'articulos-y-folletos-publicacion-4',
                'articulos-y-folletos-publicacion-5',
                'articulos-y-folletos-publicacion-6',
                'articulos-y-folletos-publicacion-7',
                'articulos-y-folletos-publicacion-8',
                'videos-publicacion-1',
                'videos-publicacion-2',
                'videos-publicacion-3',
                'videos-publicacion-4',
                'videos-publicacion-5',
                'videos-publicacion-6',
                'videos-publicacion-7',
                'videos-publicacion-8',
                'videos-publicacion-9',
            ],
        },
    },
    {
        id: 'post004',
        pretitle: null,
        title: 'Sitios de interés',
        subtitle: null,
        summary: null,
        description: null,
        url: 'sitios-de-interes',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: getCoverImage(2759806, 1280),
            },
            thumbImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sitios-de-interes.jpg',
            },
            video: null,
            gallery: [],
        },
        data: { pages: [], articles: [], sites: [] },
    },
    {
        id: 'post005',
        pretitle: null,
        title: 'Preguntas frecuentes',
        subtitle: null,
        summary:
            'Sumario pagina preguntas frecuentes. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción pagina preguntas frecuentes. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'preguntas-frecuentes',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: getCoverImage(2875010, 1280),
            },
            thumbImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/preguntas-frecuentes-thumb.jpg',
            },
            video: null,
            gallery: [],
        },
        data: { pages: [], articles: [], sites: [] },
    },
    {
        id: 'post006',
        pretitle: null,
        title: 'Mi monitora',
        subtitle: null,
        summary:
            'Sumario pagina mi monitora. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción pagina mi monitora. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'mi-monitora',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/mi-monitora.jpg',
            },
            video: null,
            gallery: [],
        },
        data: { pages: [], articles: [], sites: [] },
    },
    {
        id: 'post007',
        pretitle: null,
        title: 'Moni me guia',
        subtitle: null,
        summary:
            'Sumario pagina Moni me guia. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción pagina Moni me guia. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'moni-me-guia',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/moni-me-guia-thumb.png',
            },
            video: null,
            gallery: [],
        },
        data: { pages: [], articles: [], sites: [] },
    },
    {
        id: 'post008',
        pretitle: null,
        title: 'Datos de contacto',
        subtitle: null,
        summary: null,
        description: null,
        url: 'datos-de-contacto',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                //src: getCoverImage(5110960, 1280),
                src: 'https://bmspspbucket.s3.amazonaws.com/images/datos-de-contacto.jpg',
            },
            thumbImage: {
                aspectRatio: '5/1',
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/datos-de-contacto-thumb.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            featuredArticles: [
                'informacion-medica',
                'centro-de-contacto',
                'tienes-preguntas',
            ],
        },
    },
    {
        id: 'post009',
        pretitle: null,
        title: '¿Que ofrece el programa?',
        subtitle: null,
        summary:
            'Sumario pagina ¿que ofrece el programa?. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción pagina ¿que ofrece el programa?. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa',
        media: {
            coverImage: {
                aspectRatio: '5/1',
                caption: null,
                src: getCoverImage(368260, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            featuredArticles: [
                'que-ofrece-el-programa-articulo-01',
                'que-ofrece-el-programa-articulo-02',
                'que-ofrece-el-programa-articulo-03',
                'que-ofrece-el-programa-articulo-04',
                'que-ofrece-el-programa-articulo-05',
                'que-ofrece-el-programa-articulo-06',
            ],
        },
    },
    {
        id: 'post010',
        pretitle: null,
        title: 'Artículos y materiales',
        subtitle: null,
        summary:
            'Sumario pagina "Artículos y materiales". Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción pagina "Artículos y materiales". Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1366919, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            articles: [
                'articulos-y-materiales-publicacion-1',
                'articulos-y-materiales-publicacion-2',
                'articulos-y-materiales-publicacion-3',
                'articulos-y-materiales-publicacion-4',
                'articulos-y-materiales-publicacion-5',
                'articulos-y-materiales-publicacion-6',
                'articulos-y-materiales-publicacion-7',
                'articulos-y-materiales-publicacion-8',
                'articulos-y-materiales-publicacion-9',
                'articulos-y-materiales-publicacion-10',
                'articulos-y-materiales-publicacion-11',
                'articulos-y-materiales-publicacion-12',
            ],
        },
    },
    {
        id: 'post011',
        pretitle: null,
        title: 'Artículos y folletos',
        subtitle: null,
        summary:
            'Sumario pagina "Artículos y folletos". Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción pagina "Artículos y folletos". Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(5110960, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            articles: [
                'articulos-y-folletos-publicacion-1',
                'articulos-y-folletos-publicacion-2',
                'articulos-y-folletos-publicacion-3',
                'articulos-y-folletos-publicacion-4',
                'articulos-y-folletos-publicacion-5',
                'articulos-y-folletos-publicacion-6',
                'articulos-y-folletos-publicacion-7',
                'articulos-y-folletos-publicacion-8',
            ],
        },
    },
    {
        id: 'post012',
        pretitle: null,
        title: 'Videos',
        subtitle: null,
        summary: null,
        description: null,
        url: 'videos',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(2437291, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            posts: [
                'videos-publicacion-1',
                'videos-publicacion-2',
                'videos-publicacion-3',
                'videos-publicacion-4',
                'videos-publicacion-5',
                'videos-publicacion-6',
                'videos-publicacion-7',
                'videos-publicacion-8',
                'videos-publicacion-9',
            ],
        },
    },
    {
        id: 'post013',
        type: 'page',
        pretitle: null,
        title: '',
        subtitle: null,
        summary:
            'Linea del programa para pacientes:*800 5229 902.*Horario de atención:*Lunes a Viernes de 9:00 a.m. a 5:00 p.m.',
        description: null,
        url: 'informacion-medica',
        media: {
            coverImage: {
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-el-programa-linea-de-atencion.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: null,
        },
    },
    {
        id: 'post014',
        pretitle: null,
        title: '',
        subtitle: null,
        summary: 'Correo de contacto:*programavamoscontigo@iqvia.com',
        description: null,
        url: 'centro-de-contacto',
        media: {
            coverImage: {
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-el-progrma-correo-de-contacto.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: null,
        },
    },
    {
        id: 'post015',
        pretitle: null,
        title: null,
        subtitle: null,
        summary: 'Mi monitora',
        description: null,
        url: 'tienes-preguntas',
        media: {
            coverImage: {
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/sobre-el-programa-monitoras.jpg',
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: null,
        },
    },
    {
        id: 'post016',
        pretitle: null,
        title: '¿Que ofrece el programa? - Artículo 01',
        subtitle: null,
        summary:
            'Sumario ¿Que ofrece el programa? - Artículo 01. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción ¿Que ofrece el programa? - Artículo 01. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa-articulo-01',

        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
        content: { relatedPosts: null },
    },
    {
        id: 'post017',
        pretitle: null,
        title: '¿Que ofrece el programa? - Artículo 02',
        subtitle: null,
        summary:
            'Sumario ¿Que ofrece el programa? - Artículo 02. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción ¿Que ofrece el programa? - Artículo 02. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa-articulo-02',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: [
                'que-ofrece-el-programa-articulo-01',
                'que-ofrece-el-programa-articulo-03',
            ],
        },
    },
    {
        id: 'post018',
        pretitle: null,
        title: '¿Que ofrece el programa? - Artículo 03',
        subtitle: null,
        summary:
            'Sumario ¿Que ofrece el programa? - Artículo 03. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción ¿Que ofrece el programa? - Artículo 03. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa-articulo-03',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
        content: { relatedPosts: null },
    },
    {
        id: 'post019',
        pretitle: null,
        title: '¿Que ofrece el programa? - Artículo 04',
        subtitle: null,
        summary:
            'Sumario ¿Que ofrece el programa? - Artículo 04. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción ¿Que ofrece el programa? - Artículo 04. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa-articulo-04',
        content: { relatedPosts: null },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post020',
        pretitle: null,
        title: '¿Que ofrece el programa? - Artículo 05',
        subtitle: null,
        summary:
            'Sumario ¿Que ofrece el programa? - Artículo 05. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción ¿Que ofrece el programa? - Artículo 05. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa-articulo-05',
        content: { relatedPosts: null },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post021',
        pretitle: null,
        title: '¿Que ofrece el programa? - Artículo 06',
        subtitle: null,
        summary:
            'Sumario ¿Que ofrece el programa? - Artículo 06. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción ¿Que ofrece el programa? - Artículo 06. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'que-ofrece-el-programa-articulo-06',
        content: { relatedPosts: null },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(789382, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post022',
        pretitle: null,
        title: 'Artículos y materiales: publicación 1',
        subtitle: null,
        metaDescription: 'Enero 14, 2023',
        summary:
            'Sumario Artículo 01: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 01: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-1',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(969257, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: [
                'articulos-y-materiales-publicacion-2',
                'articulos-y-materiales-publicacion-3',
                'articulos-y-materiales-publicacion-4',
            ],
        },
    },
    {
        id: 'post023',
        pretitle: null,
        title: 'Artículos y materiales publicación 2',
        subtitle: null,
        metaDescription: 'Enero 18, 2023',
        summary:
            'Sumario Artículo 02: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 02: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-2',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(2707974, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: null,
        },
    },
    {
        id: 'post024',
        pretitle: null,
        title: 'Artículos y materiales publicación 3',
        subtitle: null,
        metaDescription: 'Enero 24, 2023',
        summary:
            'Sumario Artículo 03: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 03: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-3',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(13922621, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: null,
        },
    },
    {
        id: 'post025',
        pretitle: null,
        title: 'Artículos y materiales publicación 4',
        subtitle: null,
        metaDescription: 'Enero 27, 2023',
        summary:
            'Sumario Artículo 04: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 04: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-4',
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(839845, 1280),
            },
            video: null,
            gallery: [],
        },
        content: {
            relatedPosts: null,
        },
    },
    {
        id: 'post026',
        pretitle: null,
        title: 'Artículos y materiales publicación 5',
        subtitle: null,
        metaDescription: 'Enero 31, 2023',
        summary:
            'Sumario Artículo 05: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 05: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-5',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(297805, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post027',
        pretitle: null,
        title: 'Artículos y materiales publicación 6',
        subtitle: null,
        metaDescription: 'Febrero 4, 2023',
        summary:
            'Sumario Artículo 06: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 06: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-6',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(693434, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post028',
        pretitle: null,
        title: 'Artículos y materiales publicación 7',
        subtitle: null,
        metaDescription: 'Febrero 12, 2023',
        summary:
            'Sumario Artículo 07: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 07: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-7',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(10320717, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post029',
        pretitle: null,
        title: 'Artículos y materiales publicación 8',
        subtitle: null,
        metaDescription: 'Febrero 21, 2023',
        summary:
            'Sumario Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-8',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(2943226, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post030',
        pretitle: null,
        title: 'Artículos y materiales publicación 9',
        subtitle: null,
        metaDescription: 'Febrero 24, 2023',
        summary:
            'Sumario Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-9',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(348706, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post031',
        pretitle: null,
        title: 'Artículos y materiales publicación 10',
        subtitle: null,
        metaDescription: 'Febrero 27, 2023',
        summary:
            'Sumario Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-10',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(619950, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post032',
        pretitle: null,
        title: 'Artículos y materiales publicación 11',
        subtitle: null,
        metaDescription: 'Marzo 2, 2023',
        summary:
            'Sumario Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-11',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(8395514, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post033',
        pretitle: null,
        title: 'Artículos y materiales publicación 12',
        subtitle: null,
        metaDescription: 'Marzo 5, 2023',
        summary:
            'Sumario Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículo 08: Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-materiales-publicacion-12',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1315638, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post034',
        pretitle: null,
        title: 'Artículos y folletos publicación 1',
        subtitle: null,
        category: 'Artículos',
        date: 'Enero 9,2023',
        summary:
            'Sumario Artículos y folletos publicación 1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 1. Non odio euismod lacinia at quis. Cursus sit amet dictum sit amet justo donec enim diam. Dolor sed viverra ipsum nunc aliquet bibendum enim facilisis. Magnis dis parturient montes nascetur ridiculus mus mauris. Tincidunt eget nullam non nisi est sit amet facilisis. Quis hendrerit dolor magna eget est lorem. Vestibulum mattis ullamcorper velit sed ullamcorper morbi tincidunt ornare. Bibendum ut tristique et egestas quis ipsum suspendisse ultrices gravida. Tortor at auctor urna nunc id cursus metus aliquam. Faucibus interdum posuere lorem ipsum dolor sit amet consectetur adipiscing. Risus nec feugiat in fermentum posuere urna nec. Malesuada fames ac turpis egestas sed tempus. Et malesuada fames ac turpis.\nOrci porta non pulvinar neque laoreet. In massa tempor nec feugiat nisl pretium fusce id velit. Vestibulum morbi blandit cursus risus. At in tellus integer feugiat scelerisque varius morbi. Risus ultricies tristique nulla aliquet. Eget mauris pharetra et ultrices neque. Nisl nisi scelerisque eu ultrices vitae auctor eu. Faucibus nisl tincidunt eget nullam. Magna fringilla urna porttitor rhoncus dolor purus non enim. Orci a scelerisque purus semper. Eleifend mi in nulla posuere sollicitudin aliquam ultrices. Et tortor consequat id porta nibh venenatis cras sed. Mattis pellentesque id nibh tortor id aliquet. Non blandit massa enim nec. Scelerisque fermentum dui faucibus in ornare quam viverra orci sagittis. Vestibulum lectus mauris ultrices eros in cursus turpis massa. Etiam sit amet nisl purus in mollis nunc. Sem fringilla ut morbi tincidunt augue.\nInterdum velit euismod in pellentesque. Vitae nunc sed velit dignissim sodales ut eu sem integer. Amet cursus sit amet dictum sit amet justo. In hendrerit gravida rutrum quisque non tellus orci ac auctor. Eleifend quam adipiscing vitae proin sagittis nisl. Facilisi cras fermentum odio eu feugiat pretium nibh ipsum. At imperdiet dui accumsan sit amet nulla facilisi morbi. Dignissim sodales ut eu sem integer. Faucibus scelerisque eleifend donec pretium vulputate. Et netus et malesuada fames ac turpis. Leo integer malesuada nunc vel risus commodo viverra maecenas accumsan. Donec et odio pellentesque diam volutpat commodo sed egestas. In fermentum posuere urna nec tincidunt praesent.',
        url: 'articulos-y-folletos-publicacion-1',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/articulos-publicaciones-01.jpg',
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post035',
        pretitle: null,
        title: 'Artículos y folletos publicación 2',
        subtitle: null,
        category: 'Artículos',
        date: 'Enero 9,2023',
        summary:
            'Sumario Artículos y folletos publicación 2. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 2. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-2',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(6199600, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post036',
        pretitle: null,
        title: 'Artículos y folletos publicación 3',
        subtitle: null,
        category: 'Artículos',
        date: 'Enero 19,2023',
        summary:
            'Sumario Artículos y folletos publicación 3. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 3. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-3',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(945630, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post037',
        pretitle: null,
        title: 'Artículos y folletos publicación 4',
        subtitle: null,
        category: 'Artículos',
        date: 'Enero 23,2023',
        summary:
            'Sumario Artículos y folletos publicación 4. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 4. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-4',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(10159815, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post038',
        pretitle: null,
        title: 'Artículos y folletos publicación 5',
        subtitle: null,
        category: 'Artículos',
        date: 'Enero 30,2023',
        summary:
            'Sumario Artículos y folletos publicación 5. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 5. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-5',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(2131664, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post039',
        pretitle: null,
        title: 'Artículos y folletos publicación 6',
        subtitle: null,
        category: 'Artículos',
        date: 'Febrero 6,2023',
        summary:
            'Sumario Artículos y folletos publicación 6. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 6. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-6',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1088661, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post040',
        pretitle: null,
        title: 'Artículos y folletos publicación 7',
        subtitle: null,
        category: 'Artículos',
        date: 'Febrero 13,2023',
        summary:
            'Sumario Artículos y folletos publicación 7. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 7. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-7',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(13320402, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post041',
        pretitle: null,
        title: 'Artículos y folletos publicación 8',
        subtitle: null,
        category: 'Artículos',
        date: 'Febrero 21,2023',
        summary:
            'Sumario Artículos y folletos publicación 8. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Artículos y folletos publicación 8. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'articulos-y-folletos-publicacion-8',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1209396, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post042',
        pretitle: null,
        title: 'Videos Publicación 1',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario videos publicación 1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción videos publicación 1. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-1',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: 'https://bmspspbucket.s3.amazonaws.com/images/video-01.jpg',
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post043',
        pretitle: null,
        title: 'Videos Publicación 2',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario videos publicación 2. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción videos publicación 2. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-2',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(3974113, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post044',
        pretitle: null,
        title: 'Videos Publicación 3',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 3. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 3. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-3',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(633835, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post045',
        pretitle: null,
        title: 'Videos Publicación 4',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 4. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 4. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-4',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1080400, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post046',
        pretitle: null,
        title: 'Videos Publicación 5',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 5. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 5. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-5',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1006117, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post047',
        pretitle: null,
        title: 'Videos Publicación 6',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 6. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 6. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-6',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(4665859, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post048',
        pretitle: null,
        title: 'Videos Publicación 7',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 7. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 7. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-7',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1585896, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post049',
        pretitle: null,
        title: 'Videos Publicación 8',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 8. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 8. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-8',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(1528976, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post050',
        pretitle: null,
        title: 'Videos Publicación 9',
        subtitle: null,
        category: 'Videos',
        date: 'Febrero 21, 2023',
        summary:
            'Sumario Videos Publicación 9. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        description:
            'Descripción Videos Publicación 9. Lipsum ipsum dolor sit amet, consectetur adipiscing elit. In vulputate urna molestie, vehicula mauris id, interdum turpis. Vestibulum vestibulum finibus massa non tristique.',
        url: 'videos-publicacion-9',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(3872125, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post051',
        pretitle: null,
        title: 'Terminos y condiciones',
        subtitle: null,
        category: 'Page',
        date: null,
        summary: null,
        description: null,
        url: 'terminos-y-condiciones',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: getCoverImage(3872125, 1280),
            },
            video: null,
            gallery: [],
        },
    },
    {
        id: 'post051',
        pretitle: null,
        title: 'Mi Perfil',
        subtitle: null,
        category: 'Page',
        date: null,
        summary: null,
        description: null,
        url: 'mi-perfil',
        content: {
            relatedPosts: null,
        },
        media: {
            coverImage: {
                caption: null,
                src: 'https://images.pexels.com/photos/15858341/pexels-photo-15858341/free-photo-of-gente-mujer-cara-sonriente.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
            },
            video: null,
            gallery: [],
        },
    },
]
